const initState = {
    isLoading: false,
    data: [],
    page: 1,
    error: null,
  };
  
  const UserListReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_LOADING_USERS":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_DATA_USERS":
        return {
          ...state,
          isLoading: false,
          data: action.payload.data,
        };
      case "SET_ERROR_USERS":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default UserListReducer;